<template><div><h1>区分测试环境和生产环境</h1>
<p>如果你使用了 <code>vux2</code> 模板或者 <code>webpack</code> 模板，默认你可以直接通过判断 <code>process.env.NODE_ENV</code> 来区分</p>
<p>比如<code>统计代码</code>仅放在 <code>production</code> 环境，在不同环境里使用不同的 <code>API</code> 接口地址。</p>
<pre class="hljs"><code><span class="hljs-keyword">if</span> (process.env.NODE_ENV === <span class="hljs-string">'production'</span>) {
  <span class="hljs-comment">// 干一些线上才要做的事情</span>
}
<span class="hljs-keyword">if</span> (process.env.NODE_ENV === <span class="hljs-string">'development'</span>) {
  <span class="hljs-comment">// 干一些测试时不可告人的事情</span>
}
</code></pre>
<p>如果你是自己配置的环境，可以参考 <a href="https://webpack.js.org/plugins/define-plugin/">webpack DefinePlugin 文档</a></p>
</div></template><script>
export default {
  head: {"title":"Vue + webpack 区分测试环境和生产环境 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-webpack-env-294.vue?eb900ac6